<div class="fixed inset-y-0 left-0 z-40 w-64 bg-gray-900 text-white transition-transform duration-300 ease-in-out"
     [ngClass]="{'-translate-x-full': !menuOpen, 'translate-x-0': menuOpen}">

  <div
    class="size-full flex flex-col py-6 px-5 gap-6">

    <div class="flex items-center">
      <h2 class="text-xl font-bold flex-1">Menu</h2>
      <button (click)="onNavigate('close')" class="text-gray-400 hover:text-white focus:outline-none">
        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <div class="contents [&_button]:rounded [&_button]:bg-gray-700/10 [&_button]:hover:bg-gray-700 [&_button]:transition-colors
            [&_button]:py-2 [&_button]:px-4 [&_button]:cursor-pointer [&_button]:text-left [&_button,li]:w-full">

      <div class="flex flex-col flex-1 overflow-y-auto scrollbar-hide gap-3">
        @if(userService.username(); as user) {
          <div>
            <h3 class="font-medium">{{user.name}}</h3>
          </div>
        }
        <ul class="flex flex-col gap-2 py-3">
          <li>
            <a routerLink="/"
               [routerLinkActiveOptions]="{exact: true}"
               routerLinkActive="bg-gray-700"
               (click)="onNavigate('close')"
               class="block rounded py-2 px-4 hover:bg-gray-700 transition-colors cursor-pointer">
              Le mie Richieste
            </a>
          </li>
          <li>
            <a routerLink="/modulo-di-richiesta"
               routerLinkActive="bg-gray-700"
               (click)="onNavigate('close')"
               class="block rounded py-2 px-4 hover:bg-gray-700 transition-colors cursor-pointer">
              Modulo Richiesta
            </a>
          </li>
          <li>
            <a routerLink="/atti-amministrativi"
               routerLinkActive="bg-gray-700"
               (click)="onNavigate('close')"
               class="block rounded py-2 px-4 hover:bg-gray-700 transition-colors cursor-pointer">
              Atti Amministrativi
            </a>
          </li>
          <!--<li>
            <a routerLink="/comunicazioni"
               routerLinkActive="bg-gray-700"
               (click)="onNavigate('close')"
               class="block rounded py-2 px-4 hover:bg-gray-700 transition-colors cursor-pointer">
              Comunicazioni
            </a>
          </li>-->
          <li>
            <a routerLink="/documenti-sgi"
               routerLinkActive="bg-gray-700"
               (click)="onNavigate('close')"
               class="block rounded py-2 px-4 hover:bg-gray-700 transition-colors cursor-pointer">
              Documenti SGI
            </a>
          </li>
        </ul>
      </div>

      <div class="flex flex-col items-start gap-3">
        <button (click)="logoutRedirect()">
          Logout
        </button>
      </div>

    </div>

  </div>

</div>

<div (click)="onNavigate('close')" class="fixed inset-0 z-30 bg-black transition-opacity"
     [ngClass]="{'opacity-0 pointer-events-none': !menuOpen, 'opacity-50 pointer-events-auto': menuOpen}"></div>
